module.exports = __webpack_public_path__ + "media/images/global/breadcrumb/icon_home-dac082fdfb63a09f2ecdd270f1268328.svg";